// extracted by mini-css-extract-plugin
export var csatScore = "_md-5";
export var header = "_md-1";
export var panelWrapper = "_md-2";
export var postPreview = "_md-3";
export var rightContent = "_md-0";
export var wrappingText = "_md-4";